import styled from 'styled-components'
import { margin, MarginProps } from 'styled-system'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export interface ISubtitleProps extends MarginProps {}

export const Subtitle = styled.div<ISubtitleProps>`
  text-align: center;
  font-size: 14px;

  ${margin}
`
